import { useEffect } from "react";
import { SWRConfig } from "swr";
import request from "./ApiCall/request";
import useAuth from "./shared/hooks/useAuth";
import GeneralProvider from "./shared/provider/general.provider";
import { useHistory } from "react-router-dom";
import DomainProvider from "./shared/provider/domain.provider";
import "emoji-mart/css/emoji-mart.css";
import LocalizationProvider from "./shared/provider/localization.provider";
import useLocalization from "./shared/hooks/useLocalization";

export default function App({ children }: any) {
  require("dotenv").config();
  const { accessToken, logout } = useAuth();
  const { getLanguage, getCurrency } = useLocalization();

  const {
    location: { pathname, search },
  } = useHistory();

  // useEffect(() => {
  //   if (!localStorage.getItem("lng")) {
  //     localStorage.setItem("lng", "fa-IR");
  //   }
  // }, []);

  return (
    <>
      <SWRConfig
        value={{
          fetcher: (url) =>
            request({
              token: accessToken,
              headers: {
                clientPath: pathname,
                language: getLanguage()?.language,
                currency: getCurrency().currencyId,
              },
            })
              .get(url)
              .then((res) => res.data),
          revalidateOnFocus: false,
          errorRetryCount: 2,
          errorRetryInterval: 5000,
          onError: (err) => {
            if (err?.response?.status == 401) {
              if (process.env.NODE_ENV == "production") {
                logout();
              }
              //@ts-ignores
            }
          },
        }}
      >
        <DomainProvider>
          <GeneralProvider>{children}</GeneralProvider>
        </DomainProvider>
      </SWRConfig>
    </>
  );
}
